import { useQueryWhenAuthenticated } from 'hooks/useQueryWhenAuthenticated';
import { UserActions } from 'types';
import { AccountStatusEnum } from 'types/generated/graphql';
import { usePoorStandingContext } from 'contexts/PoorStandingContext/PoorStandingContext';
import { AccountBalanceSummaryQuery } from 'apollo/user/user.gql';
import { AccountBalanceSummaryResponse } from 'apollo/user/user.type';
import { UserFailureEvents } from '../constants';

export const useShowPoorStanding = () => {
    const { showPoorStanding } = usePoorStandingContext();

    const options = {
        onCompleted: (data: AccountBalanceSummaryResponse) => {
            const isPoorStanding =
                data?.accountBalanceSummary?.accountingStatus ===
                AccountStatusEnum.PoorStanding;

            showPoorStanding(isPoorStanding);
        },
    };

    useQueryWhenAuthenticated({
        query: AccountBalanceSummaryQuery,
        errorConfig: UserFailureEvents[UserActions.GetUserAccountStatusFailed],
        options,
    });
};
